const saveActivity = (timestamp) => {
  localStorage.setItem('activity', timestamp)
}
const DIFF = 60 * 15
const compareTimestamp = () => {
  const actualTimestamp = localStorage.getItem('activity')
  const newTime = Math.floor(new Date().getTime() / 1000)
  const secondsActual = Math.floor(actualTimestamp / 1000)
  const compare = newTime - secondsActual
  if (compare < DIFF) {
    saveActivity(new Date().getTime())
  } else {
    localStorage.clear()
    // eslint-disable-next-line no-undef
    window.location.replace(process.env.REACT_APP_LOGIN_REDIRECT)
  }
}

export default { compareTimestamp, saveActivity }
